<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="收款"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
    :modal="false"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="应收金额：">
          <el-input
            size="mini"
            v-model.trim="form.receivableAmount"
            v-number-only:20="2"
            clearable
            disabled
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="应收时间：" class="mr0">
          <el-date-picker
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            disabled
            v-model.trim="form.receivableTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="收款金额：">
          <el-input
            size="mini"
            v-model.trim="form.receiptAmount"
            v-number-only:20="2"
            placeholder="请输入收款金额"
            clearable
          >
            <span slot="suffix">元</span>
          </el-input>
        </el-form-item>
        <el-form-item label="收款时间：" class="mr0">
          <el-date-picker
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            placeholder="请选择收款时间"
            v-model.trim="form.receiptTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否开票：" prop="needInvoice">
          <el-select
            size="mini"
            v-model="form.needInvoice"
            value-key="dictionaryCode"
            placeholder="请选择是否开票"
            clearable
          >
            <el-option :key="0" label="否" :value="0"></el-option>
						<el-option :key="1" label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款人：" prop="receiptEmployeeId" class="mr0">
          <el-select
            size="mini"
            v-model="form.receiptEmployeeId"
            filterable
            placeholder="请选择收款人"
            clearable
            reserve-keyword
            :remote="true"
            collapse-tags
            :remote-method="searchUserList"
            @visible-change="searchUserList('')"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同附件：" class="input-with-col2 mr0">
          <UploadAttachments @createFile="createFile" @deleteFile="deleteFile" :fileName="form.attachmentName"/>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" class="input-with-col2 mr0">
          <el-input
            size="mini"
            v-model.trim="form.remark"
            placeholder="请输入备注"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { setFee } from "@/api/MaintenanceFeeCollected";
import { mapState } from "vuex";
import { getUserSimpleList } from "@/api/MaintenancePlan";
import UploadAttachments from "@/components/UploadAttachments"
export default {
  data() {
    return {
      form: {
        receivableTime: null,
        receivableAmount: null,
        receiptAmount: null,
        receiptTime: null,
        receiptMethod: null,
        needInvoice: null,
        remark: null,
        receiptEmployeeId: null,
        receiptEmployeeName: "",
        attachmentName: '',
        attachmentPath: ''
      },
      rules: {
        receiptAmount: [
          {
            required: true,
            message: "请输入收款金额",
            trigger: "blur",
          },
        ],
        receiptTime: [
          {
            required: true,
            message: "请选择收款时间",
            trigger: "change",
          },
        ],
        receiptMethod: [
          {
            required: true,
            message: "请选择收款方式",
            trigger: "change",
          },
        ],
        needInvoice: [
          {
            required: true,
            message: "请选择是否开票",
            trigger: "change",
          },
        ],
        receiptEmployeeId: [
          {
            required: true,
            message: "请选择收款人",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
      userList: [],
    };
  },
  props: ["editData"],
  components: {
    UploadAttachments
  },
  computed: {
    ...mapState("common/dictionary", ["zffsDicts", "sfzcDicts"]),
  },
  created() {
    this.form = { ...this.editData };
  },
  methods: {
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const params = { ...this.form };
          params.receiptAmount = params.receiptAmount * 1;
          params.receiptMethod = params.receiptMethod * 1;
          params.needInvoice = params.needInvoice * 1;
          const res = await setFee(params);
          if (res.code === 200) {
            this.$message.success("收款成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    chooseResourceType(value) {
      if (value == 3 || value == 4) {
        this.form.menuShow = 0;
      } else {
        this.form.menuShow = 1;
      }
    },
    createFile(res) {
      this.form.attachment = res.reourceAddress;
      this.form.attachmentName = res.fileName;
    },
    deleteFile() {
      this.form.attachment = '';
      this.form.attachmentName = '';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceFeeCollected/components/editDialog.vue